module.exports = __webpack_public_path__ + "media/images/logo-white-376b39eefdfc6be5a9a52d7a949d3c72.png";